import { render } from "./LogIn.vue?vue&type=template&id=79d6565e"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__